import axios from '../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const getCategories = (clinicId) => axios.get(`${API_URL}clinics/${clinicId}/article-categories`);

const getArticles = ({
    clinicId,
    pageNo = 0,
    pageSize = 10,
    sortBy = 'lastModified',
    order = 'desc',
    categoryId = 0,
    title = '',
}) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
        sortBy,
        order,
        categoryId: String(categoryId),
    });

    if (title) {
        params.set('title', title);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/articles?${params.toString()}`);
};

const getArticleById = (clinicId, id) => axios.get(`${API_URL}clinics/${clinicId}/articles/${id}`);

const searchPatientByEmail = (clinicId, searchEmail) =>
    axios.get(`${API_URL}clinics/${clinicId}/patients/search?email=${searchEmail}`);

const sendArticleToPatient = (clinicId, data) =>
    axios.post(`${API_URL}clinics/${clinicId}/articles/send-to-patients`, data);

const articlesService = {
    getCategories,
    getArticles,
    getArticleById,
    searchPatientByEmail,
    sendArticleToPatient,
};

export default articlesService;
